/**
 * Imports
 */
import { combineReducers } from '@reduxjs/toolkit';

import features from 'features';

/**
 * The app's reducer
 */
const rootReducer = combineReducers({
  user: features.user.redux.reducer,
  merchant: features.merchant.redux.reducer,
});

/**
 * Exports
 */
export { rootReducer };
